// import React, { useCallback, useEffect, useMemo, useState } from 'react';
import React, { useEffect } from 'react'
// import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next'
// import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { SubmitHandler, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
// import { addDevice, editDevice } from '@modules/devices/utils/devices';
// import { FormAddDevice, FormDevicesProps, newDeviceProps } from '@modules/devices/types/types-devices';
//import { Host } from '@modules/devices/types/types-devices'
import Host from '@interfaces/device/host'
import { editHost, saveHost } from '@services/device/host'

import BackTitlePrimary from "@components/back-buttons/back-title-primary";
import { useNavigate } from 'react-router-dom';
import FormButtons from '@modules/devices/components/form-new-device/form-components/FormButtons'
import * as yup from 'yup';
import { useSelector } from 'react-redux'
import { RootState } from '@redux/store'

type Props = {
    name: string
    changeComponent: () => void
    setBullets: () => void
    isEditing: boolean
    setEditing: (edit: boolean) => void
    hostToEdit?: Host
}

const HostForm = ({changeComponent, setBullets, isEditing, hostToEdit, setEditing}: Props) => {
  const history = useNavigate();
  const { t } = useTranslation(['myDevices'])
  const defaultOrganization = useSelector((state: RootState) => state.organizations)

  useEffect(() => {
    setBullets()
  }, [setBullets])


  const onSubmit:SubmitHandler<Host> = async (data) => {
    const host: Host = {
      deviceHostId: isEditing && hostToEdit ? hostToEdit.deviceHostId : '',
      host: data.host,
      port: data.port,
      organizationId: defaultOrganization.organizationId,
      protocol: data.protocol,
      identificationHost: data.identificationHost,
      context: data.context
    }
    if(isEditing)
      await editHost(host)
    else
      await saveHost(host)

    setCleanForm()
  }

  const setCleanForm = () => {
    setEditing(false)
    changeComponent()
  }

  const schema = yup.object().shape({
    identificationHost: yup.string().trim().required(t('form.errors.identificationHost')),
    context: yup.string().trim().required(t("form.errors.context"))
      .matches(/^(\w+([-,_]?)(\/?))+$/, { message:t("form.errors.invalidContext"), excludeEmptyString: true }),
    host: yup.string().trim().required(t('form.errors.host')).matches(/(^(\d{1,3}\.){3}(\d{1,3})$)/, { message:t('form.errors.invalidIP'), excludeEmptyString: true })
    .test('ipAddress', t('form.errors.higherIP'),
    value => {
      if(value === undefined || value.trim() === '') return true;
      return value.split('.').find(i => parseInt(i) > 255) === undefined;
    }),
    port: yup.number().max(65535, t('form.errors.maxPort')).min(0, t('form.errors.minPort')).required(t('form.errors.port')),

  }).required();

  const { register, control, handleSubmit , formState: { errors }, setValue} = useForm<Host>({
    resolver: yupResolver(schema)
  })

  return (
    <div>
      <BackTitlePrimary titleText= {t('host.addTitle')} backAction={() => history(-1)}/>
      <form onSubmit={handleSubmit(onSubmit)} className='form-margin justify-center'>
          <div className="form-field">
            <label
              className="Body2-600"
              htmlFor="protocol"
              data-end="*"
            >
              {t('form.protocol')}
            </label>
            <select className="select-primary" id="protocol" {...register('protocol', { required: "Please choose one protocol"})}>
              <option value="http">{"http"}</option>
              <option value="https">{"https"}</option>
            </select>
          </div>

          <div className="form-field">
            <label
              className="Body2-600"
              htmlFor="host"
              data-end="*"
            >
              {t('form.identificator')}
            </label>
            <input
              maxLength={64}
              defaultValue={isEditing && hostToEdit ? hostToEdit.identificationHost : ''}
              {...register('identificationHost', { required: "Please enter the identification Host." })}
              className="input-primary"
            /> <br/>
            {errors.identificationHost?.message && (
              <span className="Error" role="alert">
                  {errors.identificationHost?.message}
              </span>
            )}
          </div>
          
          <div className="form-field">
            <label
              className="Body2-600"
              htmlFor="host"
              data-end="*"
            >
              {t('form.context')}
            </label>
            <input
              maxLength={64}
              defaultValue={isEditing && hostToEdit ? hostToEdit.context : ''}
              {...register('context', { required: "Please enter the context Host." })}
              className="input-primary"
            /> <br/>
            {errors.context?.message && (
              <span className="Error" role="alert">
                  {errors.context?.message}
              </span>
            )}
          </div>

          <div className="form-field">
            <label
              className="Body2-600"
              htmlFor="host"
              data-end="*"
            >
              {t('form.ip')}
            </label>
            <input
              defaultValue={isEditing && hostToEdit ? hostToEdit.host : ''}
              {...register('host', { required: "Please enter the host." })}
              className="input-primary"
            /> <br/>
            {errors.host?.message && (
              <span className="Error" role="alert">
                  {errors.host?.message}
              </span>
            )}
          </div>

          <div className="form-field">
            <label
              className="Body2-600"
              htmlFor="port"
              data-end="*"
            >
              {t('form.port')}
            </label>
            <input
              defaultValue={isEditing && hostToEdit ? hostToEdit.port : ''}
              {...register('port', { required: "Please enter the port." })}
              maxLength={5}
              className="input-primary"
            /> <br/>
            {errors.port?.message && (
              <span className="Error" role="alert">
                  {errors.port?.message}
              </span>
            )}
          </div>

          {/* <div className="form-field">
            <p className="BlueText">
              {' '}
              (*) {t('form.required')}
            </p>
          </div> */}
     
        <FormButtons setCleanForm={setCleanForm} />
      </form>
    </div>
  );
};

export default HostForm;
